import classnames from 'classnames';

import { TooltipQuestionMarkSVG } from '../../../svgComponents/tooltipQuestionMarkSVG/TooltipQuestionMarkSVG';
import styles from './Tooltip.module.css';

export const Tooltip = (props) => {
    const { message, children, className } = props;
    const tooltipClass = classnames(styles.Tooltip, className);
    return (
        <div className={tooltipClass} data-testid={props['data-testid']}>
            <div className={styles.message}>{message}</div>
            {children ? (
                children
            ) : (
                <TooltipQuestionMarkSVG className={styles.icon} />
            )}
        </div>
    );
};
